var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import { DetailsListLayoutMode } from "@fluentui/react/lib/DetailsList";
import { Selection } from "@fluentui/react/lib/Selection";
import { ShimmeredDetailsList } from '@fluentui/react/lib/ShimmeredDetailsList';
import { TextField } from '@fluentui/react/lib/TextField';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import React from "react";
import { Subtitle } from './Subtitle';
import { Column } from './Column';
import { isNull } from '../helpers/string-helper';
import { Row } from './Row';
import { Paginator } from './Paginator';
export class DataTable extends React.Component {
    constructor(props) {
        super(props);
        this._selection = new Selection({
            onSelectionChanged: () => {
                if (this.props.onSelectedRow) {
                    this.props.onSelectedRow(this._selection.getSelection());
                }
            }
        });
        this.buildCommandBarFarItems = () => {
            const items = [];
            // Agregar elementos personalizados
            if (this.state.externalCommandBarFarItems !== void 0 && this.state.externalCommandBarFarItems.length > 0) {
                for (let i = 0; i < this.state.externalCommandBarFarItems.length; i++) {
                    const farItem = this.state.externalCommandBarFarItems[i];
                    items.push(farItem);
                }
            }
            // Agregar menú de cantidad de elementos a mostrar
            items.push({
                key: this.state.request.Length.toString(),
                iconProps: { iconName: 'NumberedList' },
                name: this.state.request.Length.toString(),
                subMenuProps: {
                    items: [
                        {
                            key: '10',
                            name: '10',
                            onClick: () => this.onChangePaginationLength(10)
                        },
                        {
                            key: '15',
                            name: '15',
                            onClick: () => this.onChangePaginationLength(15)
                        },
                        {
                            key: '20',
                            name: '20',
                            onClick: () => this.onChangePaginationLength(20)
                        },
                        {
                            key: '30',
                            name: '30',
                            onClick: () => this.onChangePaginationLength(30)
                        },
                        {
                            key: '50',
                            name: '50',
                            onClick: () => this.onChangePaginationLength(50)
                        }
                    ]
                }
            });
            return items;
        };
        this.onChangePaginationLength = (length) => {
            this.setState({
                commandBarFarItems: this.buildCommandBarFarItems(),
                request: Object.assign(Object.assign({}, this.state.request), { Length: length, Start: 1 })
            }, () => this.refreshTable());
        };
        this.state = {
            allowSearch: props.allowSearch !== undefined ? props.allowSearch : true,
            allowSortColumns: props.allowSortColumns || [],
            columns: props.columns,
            commandBarItems: [],
            emptyImageUrl: props.emptyImageUrl || 'https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/images/empty-result.svg',
            errorLoading: false,
            errorLoadingMessage: '',
            externalCommandBarFarItems: props.commandBarFarItems || [],
            isLoading: false,
            items: [],
            lastItem: 0,
            recordsFiltered: 0,
            selectionMode: props.selectionMode,
            title: props.title,
            totalPages: 0,
            request: {
                Length: props.itemsPerPage || 10,
                OrderColumn: props.initialOrderColumn || 0,
                Search: '',
                SortDirection: props.initialSortDirection || 'asc',
                Start: 1
            },
            searchText: '',
            commandBarFarItems: []
        };
    }
    componentDidMount() {
        this.setState({
            commandBarItems: this.buildCommandBar(this.props.commandBarItems || []),
            commandBarFarItems: this.buildCommandBarFarItems()
        }, () => {
            this.refreshTable();
        });
    }
    componentWillReceiveProps(props) {
        this.setState({
            allowSearch: props.allowSearch || true,
            allowSortColumns: props.allowSortColumns || [],
            columns: props.columns || [],
            commandBarItems: this.buildCommandBar(props.commandBarItems || []),
            emptyImageUrl: props.emptyImageUrl || 'https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/images/empty-result.svg',
            externalCommandBarFarItems: props.commandBarFarItems || [],
        }, () => {
            this.setState({
                commandBarFarItems: this.buildCommandBarFarItems()
            });
        });
    }
    render() {
        var _a;
        const searchClassName = (isNull(this.state.allowSearch) || this.state.allowSearch === true) ? 'ms-Grid-col ms-sm9 ms-md10 ms-lg9' : 'ms-Grid-col ms-sm12 ms-md12 ms-lg12';
        const showTitle = typeof this.state.title === 'string' && this.state.title.trim().length > 0;
        const showCommandBar = this.state.columns != null && this.state.columns.length > 0;
        const headerClassName = this.props.hideHeaders === true ? 'detail-list-no-header' : '';
        const showData = ((_a = this.state.items) === null || _a === void 0 ? void 0 : _a.length) > 0 || this.state.isLoading;
        const onSearchTextKeyUp = (event) => {
            if (!this.state.isLoading) {
                if (event.keyCode === 13) {
                    this.setState({
                        request: Object.assign(Object.assign({}, this.state.request), { Start: 1 })
                    }, () => this.refreshTable());
                }
            }
        };
        return React.createElement(React.Fragment, null,
            showTitle && React.createElement(Subtitle, { text: this.state.title }),
            showCommandBar && React.createElement(Row, null,
                React.createElement(Column, { className: searchClassName, style: { padding: '0px', paddingLeft: '8px' } },
                    React.createElement(CommandBar, { items: this.state.commandBarItems, className: 'command-bar-1', farItems: this.state.commandBarFarItems })),
                this.state.allowSearch && React.createElement(React.Fragment, null,
                    React.createElement(Column, { className: "ms-sm3 ms-md2 ms-lg3", style: { padding: '0px' } },
                        React.createElement(TooltipHost, { content: this.props.searchTooltip || '', calloutProps: { gapSpace: 0 } },
                            React.createElement(TextField, { placeholder: 'Buscar...', borderless: true, className: 'mp-search', style: { height: '40px', backgroundColor: 'rgba(244, 244, 244, 0.43)' }, onChange: (_, value) => {
                                    this.setState({
                                        searchText: value
                                    });
                                }, onKeyUp: onSearchTextKeyUp }))))),
            showData && React.createElement(Row, null,
                React.createElement(Column, { className: "ms-sm12 ms-md12 ms-lg12" },
                    React.createElement(ShimmeredDetailsList, { items: this.state.items, columns: this.state.columns, selectionMode: this.state.selectionMode, layoutMode: DetailsListLayoutMode.justified, isHeaderVisible: true, enableShimmer: this.state.isLoading, selectionPreservedOnEmptyClick: true, selection: this._selection, shimmerLines: this.state.items.length || this.state.request.Length, className: headerClassName }))),
            !showData && React.createElement(Row, null,
                React.createElement(Column, { className: "ms-sm12 ms-md12 ms-lg12", style: { textAlign: 'center' } },
                    React.createElement("img", { style: {
                            height: '128px',
                            width: '128px'
                        }, src: this.state.emptyImageUrl, alt: "Sin Resultados" }))),
            React.createElement(Row, null,
                this.state.totalPages > 0 && React.createElement("div", { className: 'ms-Grid-col ms-sm12 ms-md6 ms-lg6', style: { paddingTop: '12px' } }, !this.state.isLoading && React.createElement("span", null,
                    "Mostrando ",
                    ((this.state.request.Start - 1) * this.state.request.Length) + 1,
                    " al ",
                    this.state.lastItem,
                    " de ",
                    this.state.recordsFiltered)),
                this.state.totalPages > 0 && React.createElement("div", { className: 'ms-Grid-col ms-sm12 ms-md6 ms-lg6', style: { textAlign: 'right' } },
                    React.createElement(Paginator, { currentPage: this.state.request.Start, totalPages: this.state.totalPages, onChange: (page) => {
                            this.setState({
                                request: Object.assign(Object.assign({}, this.state.request), { Start: page })
                            }, () => this.refreshTable());
                        } }))));
    }
    refreshTable() {
        return __awaiter(this, void 0, void 0, function* () {
            this._selection.setAllSelected(false);
            this.setState({
                isLoading: true
            });
            const req = Object.assign(Object.assign({}, this.state.request), { Search: this.state.searchText });
            const response = yield this.props.onDownloadServerData(req);
            if (req.Start < 0) {
                req.Start = 0;
            }
            let lastItem = (req.Start * req.Length) + req.Length;
            if (lastItem > response.RecordsFiltered) {
                lastItem = response.RecordsFiltered;
            }
            // Actualizar datos
            this.setState({
                isLoading: false,
                totalPages: this.state.request.Length > 0 ? Math.ceil(response.RecordsFiltered / this.state.request.Length) : 0,
                items: response.Data,
                recordsFiltered: response.RecordsFiltered,
                lastItem: lastItem,
                commandBarFarItems: this.buildCommandBarFarItems()
            });
        });
    }
    buildCommandBar(items) {
        if (typeof this.props.hideRefreshButton === 'boolean' && this.props.hideRefreshButton) {
            return items;
        }
        else {
            return [
                ...items,
                {
                    key: 'refresh',
                    name: 'Actualizar',
                    iconProps: { iconName: 'Refresh' },
                    onClick: () => {
                        this.refreshTable();
                    }
                }
            ];
        }
    }
}
